// extracted by mini-css-extract-plugin
module.exports = {"root":"AccountsBlock_root___G_-z"};